import React from 'react';

export const SingleSelectionContext = React.createContext({
    selection: null
});
